// targeting_type ainda não suporta array — derivamos a segmentação a partir dos
// dados reais da campanha até que o campo passe a refletir combinações múltiplas.

// RetailMediaCampaignSegmentation é 'keyword' | 'category'; 'automatic' é válido
// no endpoint de placement/sizes mas não existe no tipo global.
type PlacementSizesSegmentation = RetailMediaCampaignSegmentation | 'automatic'

export const deriveSegmentation = (data: {
  keywords?: string[]
  banners?: { categories?: string[] }
  targetingType?: PlacementSizesSegmentation
}): PlacementSizesSegmentation | PlacementSizesSegmentation[] | undefined => {
  const segments = [
    data?.keywords?.length && 'keyword',
    data?.banners?.categories?.length && 'category'
  ].filter(Boolean) as RetailMediaCampaignSegmentation[]

  if (segments.length === 1) return segments[0]
  if (segments.length > 1) return segments
  return data?.targetingType
}
